import _features from "../../data/features";
var exports = {};
/*
 * Load this dynamically so that it
 * doesn't appear in the rollup bundle.
 */

exports.features = _features;
export default exports;